import { render, staticRenderFns } from "./newRewardDealList.vue?vue&type=template&id=8ce37848"
import script from "./newRewardDealList.vue?vue&type=script&lang=js"
export * from "./newRewardDealList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports